import React, { useState, useEffect, useRef } from 'react'
import { getUserDetails } from '../Utility/AsyncStorage';
import axios from "axios";
import { showToast } from './Toast';
import "../output.css"
import "../Styles/Modal.css"
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from 'react-tooltip'
// import Footer from './Footer';
import Loader from './Loader';
import Report from '../Utility/Report'



const DevicesTable = ({ data, onEdit, deviceToMachine, downloadCompReport, is_Warrenty, transferDevice }) => {
  const userdetails = getUserDetails()
  return (
    <div className="p-2 w-full mx-auto" style={{ height: "fit-content", maxHeight: "76vh", overflowY: "scroll", scrollbarWidth: "thin" }}>
      <div className="overflow-hidden bg-white shadow-md rounded-xl table-scroll">
        <table className="w-full border-collapse">
          {/* Table Header */}
          <thead>
            <tr className="bg-gray-200 text-black text-sm capitalize border-b table-header-group">
              <th className="px-6 py-3 text-left">s.no</th>
              <th className="px-6 py-3 text-left">Device</th>
              <th className="px-6 py-3 text-left ">Warrenty status</th>
              <th className="px-6 py-3 text-left">Machine serial no</th>
              <th className="px-6 py-3 text-left">Machine model</th>
              <th className="px-6 py-3 text-left">Client</th>
              <th className="px-6 py-3 text-left">Machine status</th>
              <th className="px-6 py-3 text-left">active time</th>
              <th className="px-6 py-3 text-left">Alert Status</th>
              <th className="px-6 py-3 text-left">Alert Time</th>
              <th className="px-6 py-3 text-left">Location</th>
              {/* {userdetails.role == "SUPER ADMIN" &&  */}
              <th className="px-6 py-3 text-center">Action</th>
              {/* } */}
            </tr>
          </thead>

          {/* Table Body */}
          <tbody className="text-gray-700 text-sm">
            {data.map((company, index) => (
              <tr
                key={index}
                className="border-b hover:bg-gray-50 transition company-table-block"
                onClick={() => deviceToMachine(company)}
              >
                <td className="px-6 py-3 text-pink-500 font-medium text-center"><span>sno</span>{index + 1}</td>
                <td className="px-6 py-3 font-medium"><span>Device</span>{1000 + parseInt(company.device_id)}</td>
                <td className="px-6 py-3 text-center"><span>Warrenty Status</span>{is_Warrenty(company.Machine_Commissioning_Date)}</td>
                <td className="px-6 py-3"><span>Machine Serial Number</span>{company.Machine_Serial_Number}</td>
                <td className="px-6 py-3 flex items-center space-x-3"><span>Machine Model</span>{company.Machine_Model}</td>
                <td className="px-6 py-3"><span>Client</span>{company.Client_Name}</td>
                <td className="px-6 py-3"><span>Machine status</span>{company.stats[0].machinesLastStatus}</td>
                {/* <td className="px-6 py-3">{company.stats[0].machinesLastStatus}</td> */}
                <td className="px-6 py-3"><span>active time</span>{company.stats[0].machinesLastActiveTime}</td>
                <td className="px-6 py-3"><span>Alert status</span>{company.stats[0].currentlyMachinesOnAlert}</td>
                <td className="px-6 py-3"><span>Alert time</span>{company.stats[0].lastMachinesOnAlertTime}</td>
                <td className="px-6 py-3"><span>Location</span>{company.location}</td>

                <td className=" text-lg items-center text-center actionButtons">
                  {/* <i
                      className="fa fa-edit text-[15px] text-center" style={{ color: (company.device_status === 'Y' ? "black" : 'gray'), opacity: (company.device_status === 'Y' ? 1 : 0.5) }}
                      data-tooltip-id="my-tooltip"
                      data-tooltip-content={company.device_status === 'Y' ? "Edit" : "Disabled"}
                      onClick={(e) => {
                        if (company.device_status === 'Y') {
                          e.stopPropagation(); // Prevent row click event
                          onEdit(company);
                        }
                      }}
                    ></i> */}

                  <i
                    className="	fa fa-exchange text-[15px] text-center" style={{ display: (userdetails.role == "SUPER ADMIN") ? "inline" : "none", padding: "0 10px", alignItems: "center" }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Transfer Device"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent row click event
                      if (!company.comp_num) return;
                      transferDevice(company)
                    }}
                  ></i>
                  <i style={{
                    padding: "5px", cursor: company.comp_num == null ? "not-allowed" : "pointer",
                    opacity: company.comp_num == null ? 0.5 : 1
                  }}
                    data-tooltip-id="my-tooltip-device-report"
                    data-tooltip-content="Download Report"
                    className="fa fa-download text-[15px]"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent row click event
                      if (!company.comp_num) return;
                      downloadCompReport(company)
                    }}
                  ></i>

                  <Tooltip id="my-tooltip-device-report" />
                </td>


              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};


function Devices(props) {
  const location = useLocation();
  const navigate = useNavigate();
  var userdetails = getUserDetails()
  let RowData = useRef([])
  // const compNum = location.state;

  // const [compNum, setCompNum] = useState(location.state)

  const [downloadReportState, setDownloadReportState] = useState(false)
  const compNum = useRef(location.state);
  const [flag, setflag] = useState(true)
  const [addDeviceState, setAddDeviceState] = useState(false)
  const [editDeviceState, setEditDeviceState] = useState(false)
  const [editDeviceDetail, setEditDeviceDetail] = useState([])
  const [deviceList, setDeviceList] = useState([])
  const [loaderState, setLoaderState] = useState(true);
  const [formData, setFormData] = useState({
    device_key: "",
    password: ""
  })
  const [compOption, setCompOption] = useState([])
  const [transferDeviceState, setTransferDeviceState] = useState(false)
  const [transferComp, setTransferComp] = useState(null)

  const handleFilterCompany = (e) => {
    compNum.current = e.target.value
    setflag(!flag)
  };


  const handleDeviceAdd = (fieldName, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value, // Dynamically update based on field name
    }));
  };

  const getDeviceList = async () => {
    try {

      let url = "https://itlapi.flovation.in/device/listOfInvDevice";
      let body = {
        comp_num: compNum.current ?? undefined,
        stats_flag: 1
      }

      // console.log("detdevice body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          setLoaderState(false)
          if (response.data.statusCode === 0) {
            // console.log("getDeviceList", response.data.op)
            setDeviceList(response.data.op)
          }
          else {
            console.log("getDeviceList", response.data.msg)
            showToast(response.data.msg, 3000, "red");
            setDeviceList([])
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
          setDeviceList([])
        }

      }).catch(error => {
        console.log("getDeviceList", error)
        if (error.response.status === 403) {
          console.log("getDeviceList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("getDeviceList else", error)
        setDeviceList([])
      })
    } catch (error) {
      console.log("getDeviceList", error)
      setDeviceList([])
    }
  }

  const handleSubmitDevice = async () => {
    try {

      let url = "https://itlapi.flovation.in/device/deviceToInv";
      let body = {
        device_key: formData.device_key,
        password: formData.password
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            console.log("handleSubmitDevice", response.data.op)
            setAddDeviceState(false)
            getDeviceList()
            showToast(response.data.msg, 3000, "green");

          }
          else {
            console.log("handleSubmitDevice", response.data.msg)
            showToast(response.data.msg, 3000, "red");
            setAddDeviceState(false)
          }
        }

        else {
          showToast(response.data.msg, 3000, "red");
          setAddDeviceState(false)
        }

      }).catch(error => {
        console.log("handleSubmitDevice", error)
        if (error.response.status === 403) {
          console.log("handleSubmitDevice if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("handleSubmitDevice else", error)
        setAddDeviceState(false)
      })
    } catch (error) {
      console.log("handleSubmitDevice", error)
      setAddDeviceState(false)
    }
  }

  const handleEdit = (item) => {
    console.log("handleEdit", item)
    setEditDeviceDetail(item)
    setEditDeviceState(true)

  }

  const handleEditDevice = async () => {
    console.log("handleEditDevice", editDeviceDetail)
    try {

      let url = "https://itlapi.flovation.in/device/updateDeviceStatus";
      let body = {
        device_id: editDeviceDetail.device_id,
        device_status: "N"
      }

      console.log("detdevice body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("getDeviceList", response.data.op)
            // setDeviceList(response.data.op)
            getDeviceList()
            setEditDeviceDetail([])
            setEditDeviceState(false)



          }
          else {
            console.log("getDeviceList", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("getDeviceList", error)
        if (error.response.status === 403) {
          console.log("getDeviceList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("getDeviceList else", error)
      })
    } catch (error) {
      console.log("getDeviceList", error)
    }
  }

  const getCompanyIdDeviceList = async () => {
    try {

      let url = "https://itlapi.flovation.in/device/listOfInvDevice";
      let body = {
        comp_num: compNum.current,
      }

      // console.log("detdevice body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("getDeviceList", response.data.op)
            // setDeviceList(response.data.op)

            const seen = new Set();

            const uniqueCompanies = response.data.op
              .filter((item) => {
                if (!seen.has(item.comp_num)) {
                  seen.add(item.comp_num);
                  return true;
                }
                return false;
              })
              .map((item) => ({
                id: item.comp_num,
                label: item.company_name,
              }))
              .sort((a, b) => (a.label == "Not Paired" ? 1 : b.label == "Not Paired" ? -1 : 0));

            // console.log("Unique Companies:", uniqueCompanies);
            setCompOption(uniqueCompanies);
          }
          else {
            console.log("getDeviceList", response.data.msg)
            showToast(response.data.msg, 3000, "red");
            setDeviceList([])
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
          setDeviceList([])
        }

      }).catch(error => {
        console.log("getDeviceList", error)
        if (error.response.status === 403) {
          console.log("getDeviceList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("getDeviceList else", error)
        setDeviceList([])
      })
    } catch (error) {
      console.log("getDeviceList", error)
      setDeviceList([])
    }
  }



  const deviceToMachine = async (item) => {
    // console.log(item)
    navigate("/machine", { state: { device_id: item.device_id, from: 'device' } })
  }

  const setComp = () => {
    if (userdetails.role === "ADMIN") {
      // setCompNum(userdetails.comp_num)
      compNum.current = userdetails.comp_num
    }
    else if (userdetails.role === "REGIONAL ADMIN") {
      // setCompNum(userdetails.comp_num)
      compNum.current = userdetails.assigned_companies
    }
  }


  const downloadCompReport = (item) => {
    RowData.current = item
    setDownloadReportState(true)
    // downloadReport()
  }
  const handleCloseModal = () => {
    setDownloadReportState(false);
  };

  const is_Warrenty = (Commi_Date) => {
    const today = new Date();
    const commissionDate = new Date(Commi_Date);

    const diffInMs = today - commissionDate;
    const diffInYears = diffInMs / (1000 * 60 * 60 * 24 * 365.25);
    const isLessThanOneYear = diffInYears < 1;
    if (diffInMs) {
      if (isLessThanOneYear) {
        return (
          <div style={{ width: 15, height: 15, backgroundColor: "green", borderRadius: "50%", alignItems: "center" }}></div>
        )
      }
      else {
        return (
          <div style={{ width: 15, height: 15, backgroundColor: "red", borderRadius: "50%", alignItems: "center" }}></div>

        )
      }
    }
    else {
      return (
        <div style={{ width: 15, height: 15, backgroundColor: "orange", borderRadius: "50%", alignItems: "center" }}></div>

      )
    }

  }

  const transferDevice = (item) => {
    RowData.current = item
    // console.log("megha1", RowData.current)
    setTransferDeviceState(true)
    setTransferComp(RowData.current.comp_num)
  }


  const handleSubmitTransferDevice = async () => {

    //  const selectedOption = compOption.find(
    //         (opt) => opt.id == transferComp
    //       );
    // console.log("megha2", RowData.current)
    // console.log("compOption:", compOption);

    try {
      let url = "https://itlapi.flovation.in/device/transferDevice";
      let body = {
        device_id: (RowData.current.device_id),
        comp_num: transferComp
      }
      console.log("Transfer device body", body)
      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {

            showToast(response.data.msg, 3000, "green");
            setTransferDeviceState(false)
            RowData.current = []
            setTransferComp(null)
          }
        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        console.log("getDeviceList", error)
        if (error.response.status === 403) {
          console.log("getDeviceList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("getDeviceList else", error)
        setDeviceList([])
      })
    } catch (error) {
      console.log("getDeviceList", error)
      showToast("Connection Error", 3000, "red")
      // setDeviceList([])
    }
  };

  useEffect(() => {
    setComp()
    getCompanyIdDeviceList()
    // if (userdetails.role === "ADMIN")
    //   getDeviceList()
  }, []);

  useEffect(() => {
    // if (userdetails.role === "SUPER ADMIN")
    getDeviceList()
  }, [flag]);

  return (
    <div style={{ width: "98%", margin: "1%" }}>

      <div className='px-2 text-lg flex justify-between items-center client-block'>
        <h1 className="text-xl font-semibold">Device Management</h1>
        <div className="flex items-center client-icon-block">

          {/* <div className="relative w-full" style={{ margin: "0 10px" }}>
            <select
              value={selectedOption}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700 bg-white appearance-none"
            >
              <option value="" disabled>Select status</option>
              {options.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.label}
                </option>
              ))}
            </select>
          </div> */}
          {
            userdetails.role == "SUPER ADMIN" ?
              <div className="relative w-full" style={{ margin: "0 10px" }}>
                <select
                  value={compNum.current}
                  onChange={handleFilterCompany}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 text-gray-700 bg-white appearance-none"
                >
                  <option value="" disabled={true} selected={!compNum.current}>
                    Select Company
                  </option>
                  {compOption.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div> :
              <></>
          }
          {
            userdetails.role == "SUPER ADMIN" &&
            <div className='px-3 py-1 bg-white borderradius-10 rounded-lg shadow-md border border-gray-300' style={{ margin: "0 5px" }}>
              <i class="fa fa-refresh" data-tooltip-id="my-tooltip1"
                data-tooltip-content="Reset Filter"
                onClick={() => {
                  compNum.current = undefined; setflag(!flag);
                }}
              ></i>
            </div>
          }
          {/* <div className='px-3 bg-white rounded-lg shadow-md cursor-pointer'>
            <i className="fa fa-plus text-blue-500" data-tooltip-id="my-tooltip"
              data-tooltip-content="Add Device" onClick={() => setAddDeviceState(true)}></i>

            <Tooltip id="my-tooltip" />
          </div> */}
        </div>
      </div>


      {
        loaderState ? (
          <Loader />
        )
          :
          deviceList.length === 0 ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "76vh" }}>
              <img
                src={require("../Assets/no_data.png")}
                alt="No Data"
                style={{
                  borderRadius: 20,
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
          ) : (

            <DevicesTable data={deviceList} onEdit={handleEdit} deviceToMachine={deviceToMachine} downloadCompReport={downloadCompReport} is_Warrenty={is_Warrenty} transferDevice={transferDevice} />

          )
      }

      {addDeviceState && (
        <div className="overlay">
          <div className="form-box">
            <h2 className="text-xl font-bold mb-4 text-center">Add Device</h2>

            {/* Input Fields */}
            <div className="space-y-4">

              {/* device key */}
              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Device key
                </label>
                <input
                  type="numeric"
                  id='device_key'
                  // placeholder="WhatsApp Number"
                  value={formData.device_key}
                  onChange={(e) => handleDeviceAdd("device_key", e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>

              {/* Password  */}
              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Password
                </label>
                <input
                  type="numeric"
                  id='password'
                  // placeholder="WhatsApp Number"
                  value={formData.password}
                  onChange={(e) => handleDeviceAdd("password", e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>
            </div>


            {/* Buttons */}
            <div className="flex justify-end space-x-3 mt-4">
              <button
                onClick={() => { setAddDeviceState(false); setFormData([]) }}
                className="px-4 py-2 bg-gray-300 rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmitDevice}
                className="px-4 py-2 bg-blue-500 text-white rounded-md"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {editDeviceState && (
        <div className="overlay">
          <div className="form-box">
            <h2 className="text-xl font-bold mb-4 text-center">Do you want to Unassign device {editDeviceDetail.device_name} ?</h2>

            {/* Input Fields */}
            {/* <div className="space-y-4">
              <div className="relative w-full" style={{ margin: "0 10px" }}>
                <select
                  value={editDeviceDetail.device_status}
                  onChange={handleEditChange}
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700 bg-white appearance-none"
                >
                  <option value="" disabled>Select status</option>
                  {options.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div> */}


            {/* Buttons */}
            <div className="flex justify-end space-x-3 mt-4">
              <button
                onClick={() => { setEditDeviceState(false); setEditDeviceDetail([]) }}
                className="px-4 py-2 bg-gray-300 rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={handleEditDevice}
                className="px-4 py-2 bg-blue-500 text-white rounded-md"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {downloadReportState && (
        <div className="overlay">
          <div className="form-box">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold text-center flex-1">Report Download</h2>
              <button
                onClick={() => setDownloadReportState(false)}
                className="px-3 py-1 bg-gray-300 rounded-md text-sm ml-4"
              >
                X
              </button>
            </div>
            <Report bodyData={RowData.current} onDownloadSuccess={handleCloseModal} />
          </div>
        </div>
      )}

      {transferDeviceState && (
        <div className="overlay">
          <div className="form-box">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold text-center flex-1">Transfer Device</h2>
              <button
                onClick={() => setTransferDeviceState(false)}
                className="px-3 py-1 bg-gray-300 rounded-md text-sm ml-4"
              >
                X
              </button>
            </div>
            <select
              value={transferComp}
              onChange={(e) => setTransferComp(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 text-gray-700 bg-white appearance-none"
            >
              <option value="" disabled={true} selected={transferComp}>
                Select Company
              </option>
              {compOption.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.label}
                </option>
              ))}
            </select>
            <button
              style={{ margin: "10px 0 0 0" }}
              className="bg-blue-500 hover:bg-blue-700 text-white px-4 py-2 rounded transition-colors duration-200 w-full"
              onClick={handleSubmitTransferDevice}
            >
              Transfer Device
            </button>
          </div>
        </div>
      )}

      {/* <Footer /> */}
    </div>
  )
}

export default Devices